define(['exports', 'moment', './elementStyleChanges'], function (exports, _moment) {
  'use strict';

  var _moment2 = _interopRequireDefault(_moment);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.getCurrentPath = function (routing) {
    return routing && routing.location ? routing.location.pathname : '';
  };

  exports.formatDate = function (date) {
    return (0, _moment2.default)(date).format("DD MMM YYYY");
  };

  exports.padZero = function (value) {
    return Number(value) < 10 ? '0' + value : '' + value;
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/utils/index.js
// module id = 460
// module chunks = 0